import Settings from "../../../../settings/Settings";
import Popup from "../../common/popup/Popup";
import Controller from "../../controller/Controller";

const HEIGHT = 970;

export default class BackModal extends Popup {
    private coin !: Phaser.GameObjects.Image;

    private farming_time: Phaser.GameObjects.BitmapText;
    private coins_farming: Phaser.GameObjects.BitmapText;

    constructor(scene: Phaser.Scene) {
        const TITLE_KEY = 'welcome_back';
        super(scene, TITLE_KEY, HEIGHT);

        this.setupContent();
        this.setupListeners();
    }

    private setupContent(): void {
        const container = this.scene.add.container(0, 20);
        const desc = this.scene.add.bitmapText(0, 0, Settings.FONTS.LXGW_CYRILLIC_BOLD, this.scene.cache.json.get('i18n')['welcome_back_description'], 41, 1)
            .setOrigin(0.5, 0)
            .setTint(0xbeb9da)
            .setMaxWidth(540)
            .setLineSpacing(-10);

        const farming_time_label = this.scene.add.bitmapText(-70, 200, Settings.FONTS.LXGW_CYRILLIC_BOLD, `${this.scene.cache.json.get('i18n')['farming_time']}:`, 42, 1)
            .setOrigin(0.5, 0)
            .setTint(0xFFFFFF)
            .setMaxWidth(540)
            .setLineSpacing(-10);

        this.farming_time = this.scene.add.bitmapText(+90, 200, Settings.FONTS.LXGW_CYRILLIC_BOLD, `11h 25m`, 43, 1)
            .setOrigin(0.5, 0)
            .setTint(0xFFF9CF)
            .setMaxWidth(540)
            .setLineSpacing(-10);

        const coins_farming_label = this.scene.add.bitmapText(-70, 250, Settings.FONTS.LXGW_CYRILLIC_BOLD, `${this.scene.cache.json.get('i18n')['coins_farmed']}:`, 42, 1)
            .setOrigin(0.5, 0)
            .setTint(0xFFFFFF)
            .setMaxWidth(540)
            .setLineSpacing(-10);

        this.coin = this.scene.add.image(+50, 275, 'atlas', 'gui/gold/icon')
            .setOrigin(0.5, 0.5)
            .setScale(0.8);

        this.coins_farming = this.scene.add.bitmapText(+80, 250, Settings.FONTS.LXGW_CYRILLIC_BOLD, `999`, 43, 1)
            .setOrigin(0, 0)
            .setTint(0xFFFFFF)
            .setMaxWidth(540)
            .setLineSpacing(-10);

        this.createButton();

        const art = this.scene.add.image(0, 705, 'preload_logo')
            .setOrigin(0.5, 0.5);

        container.add([desc, farming_time_label, this.farming_time, coins_farming_label, this.coins_farming, this.coin, art]);
        this.contentContainer.add(container);
    }

    private createButton(): void {
        const x = -165;
        const y = 350;

        const container = this.scene.add.container(x, y);
        const bgButton = this.scene.add
            .nineslice(0, 0, 'atlas', 'gui/popups/back/btn_purple', 320, 70, 24, 24, 24, 24)
            .setOrigin(0, 0);

        const label = this.scene.add.bitmapText(110, 0, Settings.FONTS.LXGW_CYRILLIC_BOLD, this.scene.cache.json.get('i18n')['claim'], 63)

        container.add([bgButton, label]);
        bgButton.setInteractive({ useHandCursor: true })
        bgButton.on("pointerdown", this.onClaim, this);

        this.contentContainer.add(container);
    }

    onClaim() {
        const { x, y } = this.coin.getWorldTransformMatrix().transformPoint(0, 0);
        super.hide()
        this.scene.events.emit('top_up_gold', { x, y });
    }

    private setupListeners(): void {
        this.scene.events.on(Controller.EVENTS.SHOW_BACK_MODAL, this.show, this);
    }

    destroy(fromScene?: boolean | undefined): void {
        if (this.scene) this.scene?.events.off(Controller.EVENTS.SHOW_BACK_MODAL, this.show, this);
        super.destroy(fromScene)
    }

    formatMsToHoursMinutes(ms: number): string {
        const totalMinutes = Math.floor(ms / (1000 * 60));
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;

        return `${hours}h ${minutes}m`;
    }

    public async show(afk_data?: { afk_reward: number, afk_time: number }): Promise<void> {
        if (!afk_data) return;

        this.farming_time.setText(this.formatMsToHoursMinutes(afk_data.afk_time))
        this.coins_farming.setText('' + afk_data.afk_reward)
        await super.show();
    }

    public async hide(): Promise<void> {
        await super.hide();
    }

}